var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { s as size, _ as __spreadValues } from "./chunk-JJ6VZ5V7-514ab153.mjs";
import * as React from "react";
import { s as styled, c as color } from "./lib-d8694455.mjs";
import "@aircall/icons";
import "@aircall/tractor-v2";
import "styled-components";
import "react-router-dom";
import "@aircall/hooks";
import "react-final-form";
import "react-dom";
import "react-router";
import "final-form";
var SvgComponent = /* @__PURE__ */ __name((props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M27.647 29.647a7.994 7.994 0 0 1-1.99 1.123C23.567 31.6 19.75 31.966 16 32c-3.75-.034-7.567-.432-9.658-1.23a7.99 7.99 0 0 1-1.99-1.123L16 18l11.647 11.647ZM4.353 2.352a7.99 7.99 0 0 1 1.99-1.123C8.432.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263a7.95 7.95 0 0 1 1.953 1.094L16 14 4.353 2.352Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#1AAF5D",
      fillRule: "evenodd",
      d: "M2.42 4.42 14 16 2.42 27.58C1.223 25.825.867 24.123.867 24.123c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 .356-1.701 1.555-3.454Zm27.16 23.16L18 16 29.585 4.415c1.22 1.766 1.582 3.494 1.582 3.494.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-.356 1.702-1.554 3.455Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M16 20.667a4.667 4.667 0 1 0 0-9.334 4.667 4.667 0 0 0 0 9.334Z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "m15.333 14-.488-.667.822.09.333-.756.333.756.822-.09-.488.667.488.667-.822-.09-.333.756-.333-.756-.822.09.488-.667Zm-2 3.333-.488-.666.822.089L14 16l.333.756.822-.09-.488.667.488.667-.822-.09-.333.757-.333-.756-.822.089.488-.667Zm4 0-.488-.666.822.089L18 16l.333.756.822-.09-.488.667.488.667-.822-.09-.333.757-.333-.756-.822.089.488-.667Z",
      clipRule: "evenodd"
    }
  )
), "SvgComponent"), SvgFlagBdi = styled(SvgComponent)`
  ${size}
  ${color}
`, FlagBdi_default = SvgFlagBdi;
export {
  FlagBdi_default as default
};
